export default __webpack_public_path__ + "images/ZL.c8f8ab8.png";